import React, { useEffect, useState } from "react";
import {
  Grid,
  Container,
  Hidden,
  Popper,
  Typography,
  useMediaQuery,
  Slide,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import HeaderDrawer from "./drawer";
import Logo from "./logo";
import SearchBarContainer from "./searchbar/searchbar";
import PersonIcon from "@material-ui/icons/Person";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import PhoneIcon from "@material-ui/icons/Phone";
import SearchDrawer from "./searchbar/search-drawer.js";
import { Link } from "gatsby";

const useStyles = makeStyles((theme) => ({
  searchBarContainer: {
    width: "100%",
    background: "#f3f3f3",
    borderRadius: 24,
    height: 40,
    padding: "5px 15px 5px 25px",
  },
  navText: {
    textTransform: "uppercase",
    fontWeight: 700,
    fontSize: 13,
    paddingTop: 2,
    margin: "0px 10px",
  },
}));

const Header = (props) => {
  const headerFilled = {
    position: "fixed",
    zIndex: 999,
    height: 60,
    maxWidth: "100vw",
    background: "#fff",
    width: "100%",
    transition: "background-color 0.5s ease",
    boxShadow: "0 3px 15px rgba(57, 63, 72, 0.1)",
    overflowX: "hidden",
  };
  const activeStyle = {
    color: "#ff1744",
  };

  const [searchDrawerOpen, setSearchDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const classes = useStyles();

  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.down("xs"));
  const matches = useMediaQuery("(max-width: 1416px)");
  const down1300 = useMediaQuery("(max-width: 1300px)");
  const down1500 = useMediaQuery("(max-width: 1500px)");
  const down1150 = useMediaQuery("(max-width: 1220px)");
  const down1000 = useMediaQuery("(max-width: 1000px)");

  const openSearchDrawer = () => {
    setSearchDrawerOpen(true);
  };
  const hideSearchDrawer = () => {
    setSearchDrawerOpen(false);
  };

  const handleSearchQuery = (query) => {
    setSearchQuery(query);
  };

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justify="flex-start"
      spacing={0}
      style={headerFilled}
    >
      <Grid
        item
        container
        xs={12}
        alignItems="center"
        justify={xsDown ? "space-between" : "center"}
        spacing={1}
        style={{ paddingLeft: 15 }}
      >
        <Grid item container xs={1} sm={7} md={6} alignItems="center">
          <HeaderDrawer color={"black"} />

          <Hidden xsDown>
            <Logo style={headerFilled} />
          </Hidden>
          <Hidden smDown>
            {!down1150 && (
              <Link color="inherit" to="/about-us" activeStyle={activeStyle}>
                <Typography
                  variant={"h6"}
                  className={classes.navText}
                  style={{ marginLeft: 35 }}
                >
                  About Us
                </Typography>
              </Link>
            )}
            <Link color="inherit" to={`/calendar`} activeStyle={activeStyle}>
              <Typography variant={"h6"} className={classes.navText}>
                Calendar
              </Typography>
            </Link>
            {!down1000 && (
              <Link
                color="inherit"
                to={`/fitness-hikes`}
                activeStyle={activeStyle}
              >
                <Typography variant={"h6"} className={classes.navText}>
                  Fitness Hikes
                </Typography>
              </Link>
            )}

            {!matches && (
              <Link
                color="inherit"
                to={`/membership`}
                activeStyle={activeStyle}
              >
                <Typography variant={"h6"} className={classes.navText}>
                  Membership
                </Typography>
              </Link>
            )}
            {/* {!down1500 && (
              <Link color="inherit" to={`/tours`} activeStyle={activeStyle}>
                <Typography variant={"h6"} className={classes.navText}>
                  How it works
                </Typography>
              </Link>
            )} */}
          </Hidden>
        </Grid>
        <Grid
          item
          container
          alignItems="center"
          justify={xsDown ? "space-between" : "flex-end"}
          style={xsDown ? { paddingLeft: 25 } : { paddingLeft: 0 }}
          xs={11}
          sm={5}
          md={6}
        >
          {!down1300 && (
            <>
              <a href="https://shop.takeshapeadventures.com.au/">
                <Typography variant={"h6"} className={classes.navText}>
                  Shop
                </Typography>
              </a>

              <Link
                color="inherit"
                to={`/packages-and-gifts`}
                activeStyle={activeStyle}
              >
                <Typography
                  variant={"h6"}
                  className={classes.navText}
                  style={{ marginRight: 20 }}
                >
                  Packages & Gifts
                </Typography>
              </Link>
            </>
          )}

          <SearchBarContainer
            openSearchDrawer={() => openSearchDrawer()}
            hideSearchDrawer={() => hideSearchDrawer()}
            handleSearchQuery={(query) => handleSearchQuery(query)}
          ></SearchBarContainer>
          <Link color="inherit" to="/login" activeStyle={activeStyle}>
            <PersonIcon style={{ marginLeft: 10 }} />
          </Link>

          <Link color="inherit" to="/cart" activeStyle={activeStyle}>
            <LocalMallIcon style={{ marginLeft: 10 }} />
          </Link>

          <Hidden smDown>
            <Link color="inherit" to="/contact-us" activeStyle={activeStyle}>
              <PhoneIcon style={{ marginLeft: 10 }} />
            </Link>
          </Hidden>

          <Popper
            open={searchDrawerOpen}
            style={{
              height: "calc(100vh - 60px)",
              background: "rgba(0,0,0,0.5)",
              width: "100%",
              zIndex: 0,
              top: 60,
              zIndex: 9999,
            }}
          >
            <SearchDrawer searchQuery={searchQuery} />
          </Popper>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Header;
